import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/table';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../../components/ui/collapsible';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '../../components/ui/popover';
import { Switch } from '../../components/ui/switch';
import { Checkbox } from '../../components/ui/checkbox';
import { Calendar as CalendarComponent } from '../../components/ui/calendar';
import { 
  ArrowDownCircle, ArrowUpCircle, Clock, FileText, 
  Loader2, RefreshCw, TrendingUp, TrendingDown, 
  Search, FileCheck, CheckCircle, XCircle, Filter, Download,
  ArrowUpDown, ArrowUp, ArrowDown, ChevronDown,
  Plus, Eye, Pencil, Trash2, Check, X, AlertTriangle,
  ChevronsUpDown, Upload, Briefcase, Building2, Calendar, Ban, ClipboardCheck, Archive, File, User, ChevronLeft, ChevronRight,
  CalendarIcon, Banknote, CreditCard, MessageSquare
} from 'lucide-react';
import { toast } from 'sonner';
import { cn } from '../../lib/utils';
import DocumentPreviewModal from '../../components/DocumentPreviewModal';
import JobDetailPopup from '../../components/JobDetailPopup';

// Muhasebe sayfalarını import et - birebir aynı içerik için
import AccountingIncome from '../accounting/AccountingIncome';
import AccountingExpenses from '../accounting/AccountingExpenses';
import AccountingFaturalar from '../accounting/AccountingFaturalar';
import AccountingTakipler from '../accounting/AccountingTakipler';
import AccountingChecks from '../accounting/AccountingChecks';
import AccountingCariHesaplar from '../accounting/AccountingCariHesaplar';
import AccountingHesapKartlari from '../accounting/AccountingHesapKartlari';
import AccountingHesapEkle from '../accounting/AccountingHesapEkle';
import AccountingCalendar from '../accounting/AccountingCalendar';
import AccountingJobs from '../accounting/AccountingJobs';
import AccountingCommunication from '../accounting/AccountingCommunication';
import AccountingWarnings from '../accounting/AccountingWarnings';
import HRArchive from '../hr/HRArchive';

const API = process.env.REACT_APP_BACKEND_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem('fortis_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Timezone-safe date formatting (local date to YYYY-MM-DD)
const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Get month name
const getMonthName = (date) => {
  const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  return `${months[date.getMonth()]} ${date.getFullYear()}`;
};

const BoardBirimMuhasebe = () => {
  const [innerTab, setInnerTab] = useState('girisler');
  const [loading, setLoading] = useState(false);
  const [showDocPreview, setShowDocPreview] = useState(false);
  const [previewBelgeler, setPreviewBelgeler] = useState([]);
  
  // Job Detail Popup State
  const [showJobPopup, setShowJobPopup] = useState(false);
  const [selectedJobId, setSelectedJobId] = useState(null);
  
  // Onay Modal State
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalRecord, setApprovalRecord] = useState(null);
  const [approvalType, setApprovalType] = useState('');
  const [approvalStatus, setApprovalStatus] = useState('');
  const [approvalBy, setApprovalBy] = useState('');
  const [approvalNote, setApprovalNote] = useState('');
  
  // Onay Detay Modal
  const [showApprovalDetailModal, setShowApprovalDetailModal] = useState(false);
  const [approvalDetailRecord, setApprovalDetailRecord] = useState(null);
  
  // Edit Modal State
  const [showEditModal, setShowEditModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [editType, setEditType] = useState('');
  const [editForm, setEditForm] = useState({});
  
  // Data states
  const [girisler, setGirisler] = useState([]);
  const [cikislar, setCikislar] = useState([]);
  const [takipler, setTakipler] = useState([]);
  const [cekler, setCekler] = useState([]);
  
  // Yeni tab verileri
  const [faturalar, setFaturalar] = useState({ girisler: [], cikislar: [] });
  const [bankaHesaplariList, setBankaHesaplariList] = useState([]);
  const [krediKartlariList, setKrediKartlariList] = useState([]);
  
  // Takvim states
  const [takvimEvents, setTakvimEvents] = useState([]);
  const [takvimTakipOdemeleri, setTakvimTakipOdemeleri] = useState([]);
  const [takvimSelectedDate, setTakvimSelectedDate] = useState(new Date());
  const [takvimCurrentMonth, setTakvimCurrentMonth] = useState(new Date());
  const [takvimLoading, setTakvimLoading] = useState(false);
  
  // İşler states
  const [isler, setIsler] = useState([]);
  const [pendingIsler, setPendingIsler] = useState([]);
  const [correctionIsler, setCorrectionIsler] = useState([]);
  const [cancelledIsler, setCancelledIsler] = useState([]);
  const [archivedIsler, setArchivedIsler] = useState([]);
  const [completedIsler, setCompletedIsler] = useState([]);
  const [preparedIsler, setPreparedIsler] = useState([]);
  const [approvedIsler, setApprovedIsler] = useState([]);
  const [todoIsler, setTodoIsler] = useState([]);
  const [islerActiveTab, setIslerActiveTab] = useState('todo');
  const [islerSearchTerm, setIslerSearchTerm] = useState('');
  const [islerSortConfig, setIslerSortConfig] = useState({ key: 'created_at', direction: 'desc' });
  const [addJobModalOpen, setAddJobModalOpen] = useState(false);
  const [jobDetailModalOpen, setJobDetailModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobFormData, setJobFormData] = useState({ konu: '', aciklama: '', belgeler: [], sube_id: '' });
  const [jobSubmitting, setJobSubmitting] = useState(false);
  const [branches, setBranches] = useState([]);
  const [branchesLoading, setBranchesLoading] = useState(true);
  
  // Job approval states
  const [correctionModalOpen, setCorrectionModalOpen] = useState(false);
  const [correctionForm, setCorrectionForm] = useState({ aciklama: '', belgeler: [] });
  const [jobActionLoading, setJobActionLoading] = useState(false);
  
  // Checkbox selection states for bulk delete
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  
  // Rejection modal states
  const [rejectionModalOpen, setRejectionModalOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');
  
  // Takipler & Cekler sub-tabs
  const [takipMainTab, setTakipMainTab] = useState('alacak');
  const [takipSubTab, setTakipSubTab] = useState('devam');
  const [cekMainTab, setCekMainTab] = useState('alinan');
  const [cekSubTab, setCekSubTab] = useState('odenecek');
  
  // Search states
  const [girisSearchTerm, setGirisSearchTerm] = useState('');
  const [cikisSearchTerm, setCikisSearchTerm] = useState('');
  const [takipSearchTerm, setTakipSearchTerm] = useState('');
  const [cekSearchTerm, setCekSearchTerm] = useState('');
  
  // Filter states - Girisler
  const [girisShowFilters, setGirisShowFilters] = useState(false);
  const [girisFilterDateFrom, setGirisFilterDateFrom] = useState('');
  const [girisFilterDateTo, setGirisFilterDateTo] = useState('');
  const [girisFilterCariHesap, setGirisFilterCariHesap] = useState('');
  const [girisFilterHesap, setGirisFilterHesap] = useState('');
  const [girisFilterSube, setGirisFilterSube] = useState('');
  const [girisFilterEtiket, setGirisFilterEtiket] = useState('');
  const [girisFilterCekKarsiligi, setGirisFilterCekKarsiligi] = useState('all');
  
  // Filter states - Cikislar
  const [cikisShowFilters, setCikisShowFilters] = useState(false);
  const [cikisFilterDateFrom, setCikisFilterDateFrom] = useState('');
  const [cikisFilterDateTo, setCikisFilterDateTo] = useState('');
  const [cikisFilterCariHesap, setCikisFilterCariHesap] = useState('');
  const [cikisFilterHesap, setCikisFilterHesap] = useState('');
  const [cikisFilterSube, setCikisFilterSube] = useState('');
  const [cikisFilterEtiket, setCikisFilterEtiket] = useState('');
  const [cikisFilterCekKarsiligi, setCikisFilterCekKarsiligi] = useState('all');
  
  // Sorting states for all tables
  const [girisSortConfig, setGirisSortConfig] = useState({ key: 'tarih', direction: 'desc' });
  const [cikisSortConfig, setCikisSortConfig] = useState({ key: 'tarih', direction: 'desc' });
  const [takipSortConfig, setTakipSortConfig] = useState({ key: 'olusturma_tarihi', direction: 'desc' });
  const [cekSortConfig, setCekSortConfig] = useState({ key: 'vade_tarihi', direction: 'desc' });
  
  // Dropdown data for edit modal
  const [cariHesaplar, setCariHesaplar] = useState([]);
  const [krediKartlari, setKrediKartlari] = useState([]);
  const [bankaHesaplari, setBankaHesaplari] = useState([]);
  const [hesapKartlari, setHesapKartlari] = useState([]);
  
  // Edit modal combobox states
  const [editCariOpen, setEditCariOpen] = useState(false);
  const [editHesapOpen, setEditHesapOpen] = useState(false);
  const [editEtiketOpen, setEditEtiketOpen] = useState(false);

  // Yeni kayıt badge sistemi
  const [viewedRecords, setViewedRecords] = useState(() => {
    const saved = localStorage.getItem('board_muhasebe_viewed');
    return saved ? JSON.parse(saved) : {};
  });
  
  const [lastViewTime, setLastViewTime] = useState(() => {
    const saved = localStorage.getItem('board_muhasebe_lastview');
    return saved ? JSON.parse(saved) : {};
  });

  // Unread counts from API
  const [unreadCounts, setUnreadCounts] = useState({
    board_muhasebe_jobs: 0,
    board_muhasebe_girisler: 0,
    board_muhasebe_cikislar: 0,
    board_muhasebe_takipler: 0,
    board_muhasebe_checks: 0
  });

  // Month navigation state for Girişler/Çıkışlar
  const [currentMonth, setCurrentMonth] = useState(() => {
    const now = new Date();
    return { year: now.getFullYear(), month: now.getMonth() };
  });
  
  const monthNames = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  
  const goToPreviousMonth = () => {
    setCurrentMonth(prev => {
      if (prev.month === 0) {
        return { year: prev.year - 1, month: 11 };
      }
      return { year: prev.year, month: prev.month - 1 };
    });
  };
  
  const goToNextMonth = () => {
    setCurrentMonth(prev => {
      if (prev.month === 11) {
        return { year: prev.year + 1, month: 0 };
      }
      return { year: prev.year, month: prev.month + 1 };
    });
  };
  
  const goToCurrentMonth = () => {
    const now = new Date();
    setCurrentMonth({ year: now.getFullYear(), month: now.getMonth() });
  };
  
  const getMonthDateRange = useMemo(() => {
    const startDate = new Date(currentMonth.year, currentMonth.month, 1);
    const endDate = new Date(currentMonth.year, currentMonth.month + 1, 0);
    return {
      start: startDate.toISOString().split('T')[0],
      end: endDate.toISOString().split('T')[0]
    };
  }, [currentMonth]);

  // Fetch unread counts
  const fetchUnreadCounts = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/notifications/unread-counts`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const data = await response.json();
        setUnreadCounts({
          board_muhasebe_jobs: data.board_muhasebe_jobs || 0,
          board_muhasebe_girisler: data.board_muhasebe_girisler || 0,
          board_muhasebe_cikislar: data.board_muhasebe_cikislar || 0,
          board_muhasebe_takipler: data.board_muhasebe_takipler || 0,
          board_muhasebe_checks: data.board_muhasebe_checks || 0
        });
      }
    } catch (error) {
      console.error('Unread counts fetch error:', error);
    }
  }, []);

  // Mark items as read when tab changes
  const markTabAsRead = useCallback(async (type) => {
    try {
      await fetch(`${API}/api/board/mark-read`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify({ type })
      });
      // Refresh unread counts after marking as read
      fetchUnreadCounts();
    } catch (error) {
      console.error('Mark as read error:', error);
    }
  }, [fetchUnreadCounts]);

  // Kayıt görüntülendiğini işaretle
  const markAsViewed = (type, id) => {
    const newViewed = { ...viewedRecords, [`${type}_${id}`]: true };
    setViewedRecords(newViewed);
    localStorage.setItem('board_muhasebe_viewed', JSON.stringify(newViewed));
  };
  
  // Kayıt yeni mi kontrol et
  const isNewRecord = (type, record) => {
    const key = `${type}_${record.id}`;
    if (viewedRecords[key]) return false;
    
    const recordTime = new Date(record.created_at || record.tarih || record.olusturma_tarihi).getTime();
    const lastView = lastViewTime[type] || 0;
    
    return recordTime > lastView;
  };

  // Yeni kayıt sayısını hesapla
  const getNewCount = (type, records) => {
    return records.filter(r => isNewRecord(type, r)).length;
  };

  // Tab değiştiğinde son görüntüleme zamanını güncelle
  const updateLastViewTime = (type) => {
    const newLastView = { ...lastViewTime, [type]: Date.now() };
    setLastViewTime(newLastView);
    localStorage.setItem('board_muhasebe_lastview', JSON.stringify(newLastView));
  };

  // Satır arka plan rengi - onay durumuna göre
  const getRowBackgroundColor = (record) => {
    const status = record.approval_status;
    if (!status) return 'bg-blue-50'; // İşlem yapılmamış - açık mavi
    if (status === 'dogru') return 'bg-green-50'; // Doğru - açık yeşil
    if (status === 'yanlis') return 'bg-red-50'; // Yanlış - açık kırmızı
    if (status === 'supheli') return 'bg-purple-50'; // Şüpheli - açık mor
    return '';
  };

  // Onay durumu badge'i
  const getApprovalBadge = (record) => {
    const status = record.approval_status;
    if (!status) return null;
    
    if (status === 'dogru') {
      return <Badge className="bg-green-100 text-green-700 text-xs"><Check className="h-3 w-3 mr-1" />Doğru</Badge>;
    }
    if (status === 'yanlis') {
      return <Badge className="bg-red-100 text-red-700 text-xs"><X className="h-3 w-3 mr-1" />Yanlış</Badge>;
    }
    if (status === 'supheli') {
      return <Badge className="bg-purple-100 text-purple-700 text-xs"><AlertTriangle className="h-3 w-3 mr-1" />Şüpheli</Badge>;
    }
    return null;
  };

  // Onay modalını aç
  const openApprovalModal = (record, type) => {
    setApprovalRecord(record);
    setApprovalType(type);
    setApprovalStatus(record.approval_status || '');
    setApprovalBy(record.approval_by || '');
    setApprovalNote(record.approval_note || '');
    setShowApprovalModal(true);
  };

  // Onay detay modalını aç
  const openApprovalDetail = (record) => {
    setApprovalDetailRecord(record);
    setShowApprovalDetailModal(true);
  };

  // Edit modalını aç
  const openEditModal = (record, type) => {
    setEditRecord(record);
    setEditType(type);
    setEditForm({ ...record });
    setShowEditModal(true);
  };

  // Onay kaydet
  const saveApproval = async () => {
    if (!approvalStatus) {
      toast.error('Lütfen bir onay durumu seçin');
      return;
    }
    if (!approvalBy.trim()) {
      toast.error('Lütfen onaylayan kişi adını girin');
      return;
    }

    try {
      const response = await fetch(`${API}/api/accounting/approval/${approvalType}/${approvalRecord.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify({
          status: approvalStatus,
          approved_by: approvalBy,
          note: approvalNote
        })
      });

      if (response.ok) {
        toast.success('Onay durumu güncellendi');
        setShowApprovalModal(false);
        fetchAllData();
      } else {
        toast.error('Onay durumu güncellenemedi');
      }
    } catch (error) {
      console.error('Onay hatası:', error);
      toast.error('Bir hata oluştu');
    }
  };

  // Düzenleme kaydet
  const saveEdit = async () => {
    const endpointMap = {
      'girisler': 'girisler',
      'cikislar': 'cikislar',
      'cekler': 'cekler',
      'alacak_takip': `takipler/alacak`,
      'borc_takip': `takipler/borc`
    };

    try {
      const response = await fetch(`${API}/api/accounting/${endpointMap[editType]}/${editRecord.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify(editForm)
      });

      if (response.ok) {
        toast.success('Kayıt güncellendi');
        setShowEditModal(false);
        fetchAllData();
      } else {
        const error = await response.json();
        toast.error(error.detail || 'Kayıt güncellenemedi');
      }
    } catch (error) {
      console.error('Düzenleme hatası:', error);
      toast.error('Bir hata oluştu');
    }
  };

  // Silme işlemi
  const handleDelete = async (type, id) => {
    if (!window.confirm('Bu kaydı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz ve Muhasebe panelinden de silinecektir.')) return;

    const endpointMap = {
      'girisler': 'girisler',
      'cikislar': 'cikislar',
      'cekler': 'cekler',
      'alacak_takip': `takipler/alacak`,
      'borc_takip': `takipler/borc`
    };

    try {
      const response = await fetch(`${API}/api/accounting/${endpointMap[type]}/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });

      if (response.ok) {
        toast.success('Kayıt silindi');
        fetchAllData();
      } else {
        toast.error('Kayıt silinemedi');
      }
    } catch (error) {
      console.error('Silme hatası:', error);
      toast.error('Bir hata oluştu');
    }
  };

  // Checkbox toggle for job selection
  const toggleJobSelection = (jobId) => {
    setSelectedJobs(prev => 
      prev.includes(jobId) 
        ? prev.filter(id => id !== jobId)
        : [...prev, jobId]
    );
  };

  // Select all jobs in current tab
  const toggleSelectAll = (jobs) => {
    const jobIds = jobs.map(j => j.id);
    const allSelected = jobIds.every(id => selectedJobs.includes(id));
    
    if (allSelected) {
      setSelectedJobs(prev => prev.filter(id => !jobIds.includes(id)));
    } else {
      setSelectedJobs(prev => [...new Set([...prev, ...jobIds])]);
    }
  };

  // Bulk delete selected jobs
  const handleBulkDeleteJobs = async () => {
    if (selectedJobs.length === 0) {
      toast.error('Lütfen silmek için iş seçin');
      return;
    }
    
    if (!window.confirm(`${selectedJobs.length} işi kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!`)) {
      return;
    }
    
    setBulkDeleteLoading(true);
    try {
      const response = await fetch(`${API}/api/board/muhasebe/isler/bulk-delete`, {
        method: 'DELETE',
        headers: {
          ...getAuthHeaders(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ job_ids: selectedJobs })
      });
      
      if (response.ok) {
        const result = await response.json();
        toast.success(`${result.deleted_count || selectedJobs.length} iş silindi`);
        setSelectedJobs([]);
        fetchIsler();
        fetchPendingIsler();
        fetchCorrectionIsler();
        fetchCancelledIsler();
        fetchCompletedIsler();
        fetchArchivedIsler();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'İşler silinemedi');
      }
    } catch (error) {
      console.error('Toplu silme hatası:', error);
      toast.error('İşler silinirken hata oluştu');
    } finally {
      setBulkDeleteLoading(false);
    }
  };

  // Fetch functions
  const fetchGirisler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/girisler`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const data = await response.json();
        setGirisler(data);
      }
    } catch (error) {
      console.error('Girişler yüklenemedi:', error);
    }
  }, []);

  const fetchCikislar = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/cikislar`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const data = await response.json();
        setCikislar(data);
      }
    } catch (error) {
      console.error('Çıkışlar yüklenemedi:', error);
    }
  }, []);

  const fetchTakipler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/takipler/${takipMainTab}`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const data = await response.json();
        setTakipler(data);
      }
    } catch (error) {
      console.error('Takipler yüklenemedi:', error);
    }
  }, [takipMainTab]);

  const fetchCekler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/cekler?tip=${cekMainTab}&durum=${cekSubTab}`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const data = await response.json();
        setCekler(data);
      }
    } catch (error) {
      console.error('Çekler yüklenemedi:', error);
    }
  }, [cekMainTab, cekSubTab]);

  // Takvim fonksiyonları
  const fetchTakvim = useCallback(async () => {
    setTakvimLoading(true);
    try {
      const headers = getAuthHeaders();
      const [eventsRes, takipRes] = await Promise.all([
        fetch(`${API}/api/accounting/takvim`, { headers }),
        fetch(`${API}/api/accounting/takvim/takip-odemeleri`, { headers })
      ]);
      
      if (eventsRes.ok) setTakvimEvents(await eventsRes.json());
      if (takipRes.ok) setTakvimTakipOdemeleri(await takipRes.json());
    } catch (error) {
      console.error('Takvim verileri yüklenemedi:', error);
    } finally {
      setTakvimLoading(false);
    }
  }, []);

  const fetchBranches = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/branches`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const data = await response.json();
        setBranches(data);
      }
    } catch (error) {
      console.error('Şubeler yüklenemedi:', error);
    }
  }, []);

  const fetchDropdownData = useCallback(async () => {
    try {
      const headers = getAuthHeaders();

      const [cariRes, krediRes, bankaRes, etiketRes] = await Promise.all([
        fetch(`${API}/api/accounting/cari-hesaplar`, { headers }),
        fetch(`${API}/api/accounting/kredi-kartlari`, { headers }),
        fetch(`${API}/api/accounting/banka-hesaplari`, { headers }),
        fetch(`${API}/api/accounting/hesap-kartlari`, { headers })
      ]);

      if (cariRes.ok) setCariHesaplar(await cariRes.json());
      if (krediRes.ok) setKrediKartlari(await krediRes.json());
      if (bankaRes.ok) setBankaHesaplari(await bankaRes.json());
      if (etiketRes.ok) setHesapKartlari(await etiketRes.json());
    } catch (error) {
      console.error('Dropdown verileri yüklenemedi:', error);
    }
  }, []);

  // İşler fonksiyonları
  const fetchIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler?status=active`, { headers: getAuthHeaders() });
      if (response.ok) setIsler(await response.json());
    } catch (error) {
      console.error('İşler yüklenemedi:', error);
    }
  }, []);

  const fetchPendingIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler?status=pending`, { headers: getAuthHeaders() });
      if (response.ok) setPendingIsler(await response.json());
    } catch (error) {
      console.error('Onay bekleyen işler yüklenemedi:', error);
    }
  }, []);

  const fetchCorrectionIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler?status=needs_correction`, { headers: getAuthHeaders() });
      if (response.ok) setCorrectionIsler(await response.json());
    } catch (error) {
      console.error('Düzeltilmesi gereken işler yüklenemedi:', error);
    }
  }, []);

  const fetchCancelledIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler?status=cancelled`, { headers: getAuthHeaders() });
      if (response.ok) setCancelledIsler(await response.json());
    } catch (error) {
      console.error('İptal edilen işler yüklenemedi:', error);
    }
  }, []);

  const fetchArchivedIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler/archived`, { headers: getAuthHeaders() });
      if (response.ok) setArchivedIsler(await response.json());
    } catch (error) {
      console.error('Arşivlenmiş işler yüklenemedi:', error);
    }
  }, []);

  const fetchCompletedIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler?status=completed`, { headers: getAuthHeaders() });
      if (response.ok) {
        const data = await response.json();
        setCompletedIsler(data);
      }
    } catch (error) {
      console.error('Bitirilen işler yüklenemedi:', error);
    }
  }, []);

  const fetchPreparedIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler?status=prepared`, { headers: getAuthHeaders() });
      if (response.ok) {
        const data = await response.json();
        setPreparedIsler(data);
      }
    } catch (error) {
      console.error('Hazırlanan işler yüklenemedi:', error);
    }
  }, []);

  const fetchApprovedIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler?status=approved`, { headers: getAuthHeaders() });
      if (response.ok) {
        const data = await response.json();
        setApprovedIsler(data);
      }
    } catch (error) {
      console.error('Onaylanan işler yüklenemedi:', error);
    }
  }, []);

  const fetchTodoIsler = useCallback(async () => {
    try {
      const response = await fetch(`${API}/api/accounting/isler?status=todo`, { headers: getAuthHeaders() });
      if (response.ok) {
        const data = await response.json();
        setTodoIsler(data);
      }
    } catch (error) {
      console.error('Yapılacak işler yüklenemedi:', error);
    }
  }, []);

  const fetchBranchesForJobs = useCallback(async () => {
    setBranchesLoading(true);
    try {
      const response = await fetch(`${API}/api/branches`, { headers: getAuthHeaders() });
      if (response.ok) setBranches(await response.json());
    } catch (error) {
      console.error('Şubeler yüklenemedi:', error);
    }
    setBranchesLoading(false);
  }, []);

  const handleJobSubmit = async () => {
    if (!jobFormData.konu.trim()) {
      toast.error('İşin konusu zorunludur');
      return;
    }
    setJobSubmitting(true);
    try {
      const response = await fetch(`${API}/api/accounting/isler`, {
        method: 'POST',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
          konu: jobFormData.konu,
          aciklama: jobFormData.aciklama,
          belgeler: jobFormData.belgeler,
          sube_id: jobFormData.sube_id || null
        })
      });
      if (response.ok) {
        toast.success('İş başarıyla oluşturuldu - Onay bekliyor');
        setAddJobModalOpen(false);
        setJobFormData({ konu: '', aciklama: '', belgeler: [], sube_id: '' });
        setIslerActiveTab('pending');
        fetchPendingIsler();
      } else {
        const error = await response.json();
        toast.error(error.detail || 'İş oluşturulamadı');
      }
    } catch (error) {
      toast.error('İş oluşturulamadı');
    }
    setJobSubmitting(false);
  };

  const handleJobDelete = async (jobId) => {
    if (!window.confirm('Bu işi silmek istediğinizden emin misiniz?')) return;
    try {
      const response = await fetch(`${API}/api/accounting/isler/${jobId}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      if (response.ok) {
        toast.success('İş silindi');
        fetchIsler();
        fetchPendingIsler();
      } else {
        toast.error('İş silinemedi');
      }
    } catch (error) {
      toast.error('İş silinemedi');
    }
  };

  const handleJobFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    const newBelgeler = [];
    for (const file of files) {
      const reader = new FileReader();
      const base64 = await new Promise((resolve) => {
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      newBelgeler.push({ name: file.name, size: file.size, type: file.type, url: base64 });
    }
    setJobFormData(prev => ({ ...prev, belgeler: [...prev.belgeler, ...newBelgeler] }));
  };

  const removeJobFile = (index) => {
    setJobFormData(prev => ({ ...prev, belgeler: prev.belgeler.filter((_, i) => i !== index) }));
  };

  // Job approval functions
  const handleJobApprove = async () => {
    if (!selectedJob) return;
    setJobActionLoading(true);
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/isler/${selectedJob.id}/approve`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        toast.success('İş onaylandı ve Onaylanan İşlere taşındı');
        setJobDetailModalOpen(false);
        fetchPendingIsler();
        fetchApprovedIsler();
      } else {
        toast.error('İş onaylanamadı');
      }
    } catch (error) {
      toast.error('İş onaylanamadı');
    }
    setJobActionLoading(false);
  };

  // Yönetim Kurulu - Hazırlanan işi onayla (işlemleri veritabanına yaz)
  const handleBoardApprove = async (job) => {
    if (!job) return;
    if (!window.confirm(`"${job.konu}" işini onaylamak istiyor musunuz? İşlemler veritabanına kaydedilecek.`)) return;
    
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/isler/${job.id}/board-approve`, {
        method: 'PUT',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: '' })
      });
      if (response.ok) {
        const result = await response.json();
        toast.success(result.message || 'İş onaylandı ve Yapılacak İşlere aktarıldı');
        fetchPreparedIsler();
        fetchTodoIsler();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'İş onaylanamadı');
      }
    } catch (error) {
      toast.error('İş onaylanamadı');
    }
  };

  // Yönetim Kurulu - Hazırlanan işi reddet
  const handleBoardReject = async (job) => {
    if (!job) return;
    const reason = window.prompt(`"${job.konu}" işini reddetmek istiyor musunuz? Red nedenini yazın:`);
    if (!reason) return;
    
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/isler/${job.id}/board-reject`, {
        method: 'PUT',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ note: reason })
      });
      if (response.ok) {
        toast.success('İş reddedildi');
        fetchPreparedIsler();
        fetchCancelledIsler();
      } else {
        const err = await response.json();
        toast.error(err.detail || 'İş reddedilemedi');
      }
    } catch (error) {
      toast.error('İş reddedilemedi');
    }
  };

  const handleJobReject = async () => {
    if (!selectedJob) return;
    if (!rejectionReason.trim()) {
      toast.error('Red açıklaması zorunludur');
      return;
    }
    setJobActionLoading(true);
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/isler/${selectedJob.id}/reject-with-reason`, {
        method: 'PUT',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ aciklama: rejectionReason })
      });
      if (response.ok) {
        toast.success('İş reddedildi ve İptal Edilenler\'e taşındı');
        setRejectionModalOpen(false);
        setJobDetailModalOpen(false);
        setRejectionReason('');
        fetchPendingIsler();
        fetchCancelledIsler();
      } else {
        toast.error('İş reddedilemedi');
      }
    } catch (error) {
      toast.error('İş reddedilemedi');
    }
    setJobActionLoading(false);
  };

  const openRejectionModal = () => {
    setRejectionReason('');
    setRejectionModalOpen(true);
  };

  const openCorrectionModal = () => {
    setCorrectionForm({ aciklama: '', belgeler: [] });
    setCorrectionModalOpen(true);
  };

  const handleCorrectionFileUpload = async (e) => {
    const files = Array.from(e.target.files);
    const newBelgeler = [];
    for (const file of files) {
      const reader = new FileReader();
      const base64 = await new Promise((resolve) => {
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      newBelgeler.push({ name: file.name, size: file.size, type: file.type, url: base64 });
    }
    setCorrectionForm(prev => ({ ...prev, belgeler: [...prev.belgeler, ...newBelgeler] }));
  };

  const removeCorrectionFile = (index) => {
    setCorrectionForm(prev => ({ ...prev, belgeler: prev.belgeler.filter((_, i) => i !== index) }));
  };

  const handleCorrectionSubmit = async () => {
    if (!selectedJob) return;
    if (!correctionForm.aciklama.trim()) {
      toast.error('Düzeltme açıklaması zorunludur');
      return;
    }
    setJobActionLoading(true);
    try {
      const token = localStorage.getItem('fortis_token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/accounting/isler/${selectedJob.id}/correction`, {
        method: 'PUT',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(correctionForm)
      });
      if (response.ok) {
        toast.success('Düzeltme talebi gönderildi');
        setCorrectionModalOpen(false);
        setJobDetailModalOpen(false);
        fetchPendingIsler();
        fetchCorrectionIsler();
      } else {
        toast.error('Düzeltme talebi gönderilemedi');
      }
    } catch (error) {
      toast.error('Düzeltme talebi gönderilemedi');
    }
    setJobActionLoading(false);
  };

  const islerStats = useMemo(() => {
    return {
      activeCount: isler.length,
      pendingCount: pendingIsler.length,
      correctionCount: correctionIsler.length,
      cancelledCount: cancelledIsler.length,
      totalJobs: isler.length + pendingIsler.length + correctionIsler.length + cancelledIsler.length
    };
  }, [isler, pendingIsler, correctionIsler, cancelledIsler]);

  const filteredIsler = useMemo(() => {
    let result;
    if (islerActiveTab === 'archive') result = archivedIsler;
    else if (islerActiveTab === 'completed') result = completedIsler;
    else if (islerActiveTab === 'pending') result = pendingIsler;
    else if (islerActiveTab === 'correction') result = correctionIsler;
    else if (islerActiveTab === 'cancelled') result = cancelledIsler;
    else if (islerActiveTab === 'prepared') result = preparedIsler;
    else if (islerActiveTab === 'approved') result = approvedIsler;
    else if (islerActiveTab === 'todo') result = todoIsler;
    else result = isler;
    
    if (islerSearchTerm) {
      const term = islerSearchTerm.toLowerCase();
      result = result.filter(job => 
        job.konu?.toLowerCase().includes(term) ||
        job.aciklama?.toLowerCase().includes(term) ||
        job.sube_adi?.toLowerCase().includes(term)
      );
    }
    
    return [...result].sort((a, b) => {
      const aVal = a[islerSortConfig.key] || '';
      const bVal = b[islerSortConfig.key] || '';
      return islerSortConfig.direction === 'asc' ? (aVal > bVal ? 1 : -1) : (aVal < bVal ? 1 : -1);
    });
  }, [isler, pendingIsler, correctionIsler, cancelledIsler, archivedIsler, completedIsler, preparedIsler, approvedIsler, todoIsler, islerActiveTab, islerSearchTerm, islerSortConfig]);

  const getJobStatusBadge = (status) => {
    const config = {
      active: { label: 'Aktif', className: 'bg-green-100 text-green-700 border-green-300' },
      pending: { label: 'Beklemede', className: 'bg-yellow-100 text-yellow-700 border-yellow-300' },
      needs_correction: { label: 'Düzeltilmeli', className: 'bg-orange-100 text-orange-700 border-orange-300' },
      completed: { label: 'Tamamlandı', className: 'bg-blue-100 text-blue-700 border-blue-300' },
      cancelled: { label: 'İptal', className: 'bg-red-100 text-red-700 border-red-300' },
      archived: { label: 'Arşiv', className: 'bg-gray-100 text-gray-700 border-gray-300' },
      prepared: { label: 'Hazırlandı', className: 'bg-emerald-100 text-emerald-700 border-emerald-300' },
      approved: { label: 'Onaylandı', className: 'bg-green-100 text-green-700 border-green-300' },
      todo: { label: 'Yapılacak', className: 'bg-purple-100 text-purple-700 border-purple-300' }
    }[status] || { label: 'Aktif', className: 'bg-green-100 text-green-700 border-green-300' };
    return <Badge variant="outline" className={config.className}>{config.label}</Badge>;
  };

  const fetchAllData = useCallback(async () => {
    setLoading(true);
    await Promise.all([
      fetchGirisler(),
      fetchCikislar(),
      fetchTakipler(),
      fetchCekler(),
      fetchBranches(),
      fetchDropdownData(),
      fetchIsler(),
      fetchPendingIsler(),
      fetchCorrectionIsler(),
      fetchCancelledIsler(),
      fetchPreparedIsler(),
      fetchApprovedIsler(),
      fetchTodoIsler(),
      fetchBranchesForJobs(),
      fetchTakvim()
    ]);
    setLoading(false);
  }, [fetchGirisler, fetchCikislar, fetchTakipler, fetchCekler, fetchBranches, fetchDropdownData, fetchIsler, fetchPendingIsler, fetchCorrectionIsler, fetchCancelledIsler, fetchPreparedIsler, fetchApprovedIsler, fetchTodoIsler, fetchBranchesForJobs, fetchTakvim]);

  useEffect(() => {
    fetchAllData();
    fetchUnreadCounts(); // Unread counts'ı başlangıçta yükle
  }, [fetchAllData, fetchUnreadCounts]);

  // Tab değiştiğinde mark-as-read çağır ve unread counts güncelle
  useEffect(() => {
    if (innerTab === 'girisler') {
      markTabAsRead('girisler');
    } else if (innerTab === 'cikislar') {
      markTabAsRead('cikislar');
    } else if (innerTab === 'takipler') {
      markTabAsRead('takipler');
    } else if (innerTab === 'cekler') {
      markTabAsRead('cekler');
    } else if (innerTab === 'isler') {
      markTabAsRead('isler');
    } else if (innerTab === 'takvim') {
      fetchTakvim();
    }
  }, [innerTab, markTabAsRead, fetchTakvim]);

  // İşler tab değiştiğinde verileri yenile
  useEffect(() => {
    if (islerActiveTab === 'archive') fetchArchivedIsler();
    else if (islerActiveTab === 'completed') fetchCompletedIsler();
    else if (islerActiveTab === 'pending') fetchPendingIsler();
    else if (islerActiveTab === 'correction') fetchCorrectionIsler();
    else if (islerActiveTab === 'cancelled') fetchCancelledIsler();
    else if (islerActiveTab === 'prepared') fetchPreparedIsler();
    else if (islerActiveTab === 'approved') fetchApprovedIsler();
    else if (islerActiveTab === 'todo') fetchTodoIsler();
    else fetchIsler();
  }, [islerActiveTab, fetchIsler, fetchPendingIsler, fetchCorrectionIsler, fetchCancelledIsler, fetchArchivedIsler, fetchCompletedIsler, fetchPreparedIsler, fetchApprovedIsler, fetchTodoIsler]);

  useEffect(() => {
    fetchTakipler();
  }, [takipMainTab, fetchTakipler]);

  useEffect(() => {
    fetchCekler();
  }, [cekMainTab, cekSubTab, fetchCekler]);

  // Tab değiştiğinde last view time güncelle
  useEffect(() => {
    updateLastViewTime(innerTab);
  }, [innerTab]);

  // Format currency with multi-currency support
  const formatCurrency = (amount, currency = 'TL') => {
    const currencyMap = {
      'TL': 'TRY',
      'USD': 'USD',
      'EUR': 'EUR'
    };
    return new Intl.NumberFormat('tr-TR', { 
      style: 'currency', 
      currency: currencyMap[currency] || 'TRY' 
    }).format(amount || 0);
  };

  // Get currency symbol
  const getCurrencySymbol = (currency) => {
    const symbols = { 'TL': '₺', 'USD': '$', 'EUR': '€' };
    return symbols[currency] || '₺';
  };

  // Generic sorting function
  const handleSort = (key, type) => {
    if (type === 'giris') {
      setGirisSortConfig(prev => ({
        key,
        direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
      }));
    } else if (type === 'cikis') {
      setCikisSortConfig(prev => ({
        key,
        direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
      }));
    } else if (type === 'takip') {
      setTakipSortConfig(prev => ({
        key,
        direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
      }));
    } else if (type === 'cek') {
      setCekSortConfig(prev => ({
        key,
        direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
      }));
    }
  };

  // Sort icon component
  const SortIcon = ({ columnKey, sortConfig }) => {
    if (sortConfig.key !== columnKey) {
      return <ArrowUpDown className="h-3 w-3 ml-1 text-gray-400" />;
    }
    return sortConfig.direction === 'asc' 
      ? <ArrowUp className="h-3 w-3 ml-1 text-blue-600" />
      : <ArrowDown className="h-3 w-3 ml-1 text-blue-600" />;
  };

  // Sortable header component
  const SortableHeader = ({ children, columnKey, sortConfig, onSort, className = "" }) => (
    <TableHead 
      className={cn("cursor-pointer hover:bg-gray-100 select-none", className)}
      onClick={onSort}
    >
      <div className="flex items-center">
        {children}
        <SortIcon columnKey={columnKey} sortConfig={sortConfig} />
      </div>
    </TableHead>
  );

  // Sort helper function
  const sortData = (data, sortConfig) => {
    return [...data].sort((a, b) => {
      let aVal = a[sortConfig.key];
      let bVal = b[sortConfig.key];
      
      // Handle numeric values
      if (['miktar', 'tutar', 'toplam_tutar'].includes(sortConfig.key)) {
        aVal = parseFloat(aVal) || 0;
        bVal = parseFloat(bVal) || 0;
      }
      
      // Handle dates
      if (['tarih', 'vade_tarihi', 'olusturma_tarihi', 'duzenleme_tarihi'].includes(sortConfig.key)) {
        aVal = new Date(aVal || 0).getTime();
        bVal = new Date(bVal || 0).getTime();
      }
      
      // Handle status sorting (approved > pending > rejected/null)
      if (['onay_durumu', 'approval_status'].includes(sortConfig.key)) {
        const statusOrder = { 'approved': 3, 'pending': 2, 'rejected': 1 };
        aVal = statusOrder[aVal] || 0;
        bVal = statusOrder[bVal] || 0;
      }
      
      // Handle null/undefined
      if (aVal == null) aVal = '';
      if (bVal == null) bVal = '';
      
      if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

  // Filtered and sorted data - Girisler
  const filteredGirisler = useMemo(() => {
    let result = [...girisler];
    
    // Apply month filter by default
    const monthRange = getMonthDateRange;
    result = result.filter(g => {
      if (!g.tarih) return false;
      return g.tarih >= monthRange.start && g.tarih <= monthRange.end;
    });
    
    // Search filter
    if (girisSearchTerm) {
      const term = girisSearchTerm.toLowerCase();
      result = result.filter(g => 
        g.cari_hesap_adi?.toLowerCase().includes(term) ||
        g.hesap_adi?.toLowerCase().includes(term) ||
        g.aciklama?.toLowerCase().includes(term)
      );
    }
    
    // Additional date filters (within selected month)
    if (girisFilterDateFrom) {
      result = result.filter(g => g.tarih >= girisFilterDateFrom);
    }
    if (girisFilterDateTo) {
      result = result.filter(g => g.tarih <= girisFilterDateTo);
    }
    
    // Other filters
    if (girisFilterCariHesap) {
      result = result.filter(g => g.cari_hesap_adi?.toLowerCase().includes(girisFilterCariHesap.toLowerCase()));
    }
    if (girisFilterHesap) {
      result = result.filter(g => g.hesap_adi?.toLowerCase().includes(girisFilterHesap.toLowerCase()));
    }
    if (girisFilterSube) {
      result = result.filter(g => g.fortis_sube === girisFilterSube);
    }
    if (girisFilterEtiket) {
      result = result.filter(g => g.etiket_adi?.toLowerCase().includes(girisFilterEtiket.toLowerCase()));
    }
    if (girisFilterCekKarsiligi !== 'all') {
      result = result.filter(g => girisFilterCekKarsiligi === 'yes' ? g.cek_karsiligi : !g.cek_karsiligi);
    }
    
    // Sorting
    return sortData(result, girisSortConfig);
  }, [girisler, girisSearchTerm, girisFilterDateFrom, girisFilterDateTo, girisFilterCariHesap, girisFilterHesap, girisFilterSube, girisFilterEtiket, girisFilterCekKarsiligi, girisSortConfig, getMonthDateRange]);

  // Filtered and sorted data - Cikislar
  const filteredCikislar = useMemo(() => {
    let result = [...cikislar];
    
    // Apply month filter by default
    const monthRange = getMonthDateRange;
    result = result.filter(c => {
      if (!c.tarih) return false;
      return c.tarih >= monthRange.start && c.tarih <= monthRange.end;
    });
    
    // Search filter
    if (cikisSearchTerm) {
      const term = cikisSearchTerm.toLowerCase();
      result = result.filter(c => 
        c.cari_hesap_adi?.toLowerCase().includes(term) ||
        c.hesap_adi?.toLowerCase().includes(term) ||
        c.aciklama?.toLowerCase().includes(term)
      );
    }
    
    // Additional date filters (within selected month)
    if (cikisFilterDateFrom) {
      result = result.filter(c => c.tarih >= cikisFilterDateFrom);
    }
    if (cikisFilterDateTo) {
      result = result.filter(c => c.tarih <= cikisFilterDateTo);
    }
    
    // Other filters
    if (cikisFilterCariHesap) {
      result = result.filter(c => c.cari_hesap_adi?.toLowerCase().includes(cikisFilterCariHesap.toLowerCase()));
    }
    if (cikisFilterHesap) {
      result = result.filter(c => c.hesap_adi?.toLowerCase().includes(cikisFilterHesap.toLowerCase()));
    }
    if (cikisFilterSube) {
      result = result.filter(c => c.fortis_sube === cikisFilterSube);
    }
    if (cikisFilterEtiket) {
      result = result.filter(c => c.etiket_adi?.toLowerCase().includes(cikisFilterEtiket.toLowerCase()));
    }
    if (cikisFilterCekKarsiligi !== 'all') {
      result = result.filter(c => cikisFilterCekKarsiligi === 'yes' ? c.cek_karsiligi : !c.cek_karsiligi);
    }
    
    // Sorting
    return sortData(result, cikisSortConfig);
  }, [cikislar, cikisSearchTerm, cikisFilterDateFrom, cikisFilterDateTo, cikisFilterCariHesap, cikisFilterHesap, cikisFilterSube, cikisFilterEtiket, cikisFilterCekKarsiligi, cikisSortConfig, getMonthDateRange]);

  // Filtered takipler
  const filteredTakipler = useMemo(() => {
    let result = [...takipler];
    
    // Filter by sub-tab (devam/tamamlandi)
    if (takipSubTab === 'devam') {
      result = result.filter(t => t.durum === 'devam_ediyor');
    } else {
      result = result.filter(t => t.durum === 'tamamlandi');
    }
    
    // Search filter
    if (takipSearchTerm) {
      const term = takipSearchTerm.toLowerCase();
      result = result.filter(t => 
        t.cari_hesap_adi?.toLowerCase().includes(term) ||
        t.aciklama?.toLowerCase().includes(term)
      );
    }
    
    // Sorting
    return sortData(result, takipSortConfig);
  }, [takipler, takipSubTab, takipSearchTerm, takipSortConfig]);

  // Filtered cekler
  const filteredCekler = useMemo(() => {
    let result = [...cekler];
    
    if (cekSearchTerm) {
      const term = cekSearchTerm.toLowerCase();
      result = result.filter(c => 
        c.cek_no?.toLowerCase().includes(term) ||
        c.kesideci?.toLowerCase().includes(term) ||
        c.alici?.toLowerCase().includes(term) ||
        c.banka?.toLowerCase().includes(term)
      );
    }
    
    // Sorting
    return sortData(result, cekSortConfig);
  }, [cekler, cekSearchTerm, cekSortConfig]);

  // Statistics with currency breakdown
  const girisStats = useMemo(() => {
    const totals = { TL: 0, USD: 0, EUR: 0 };
    filteredGirisler.forEach(g => {
      const currency = g.para_birimi || 'TL';
      totals[currency] = (totals[currency] || 0) + (parseFloat(g.miktar) || 0);
    });
    return {
      toplam: filteredGirisler.reduce((sum, g) => sum + (parseFloat(g.miktar) || 0), 0),
      adet: filteredGirisler.length,
      cekKarsiligi: filteredGirisler.filter(g => g.cek_karsiligi).length,
      totalsByCurrency: totals
    };
  }, [filteredGirisler]);

  const cikisStats = useMemo(() => {
    const totals = { TL: 0, USD: 0, EUR: 0 };
    filteredCikislar.forEach(c => {
      const currency = c.para_birimi || 'TL';
      totals[currency] = (totals[currency] || 0) + (parseFloat(c.miktar) || 0);
    });
    return {
      toplam: filteredCikislar.reduce((sum, c) => sum + (parseFloat(c.miktar) || 0), 0),
      adet: filteredCikislar.length,
      cekKarsiligi: filteredCikislar.filter(c => c.cek_karsiligi).length,
      totalsByCurrency: totals
    };
  }, [filteredCikislar]);

  // Takip stats with currency breakdown
  const takipStats = useMemo(() => {
    const totals = { TL: 0, USD: 0, EUR: 0 };
    filteredTakipler.forEach(t => {
      const currency = t.para_birimi || 'TL';
      totals[currency] = (totals[currency] || 0) + (parseFloat(t.toplam_tutar) || 0);
    });
    const devamEdenler = filteredTakipler.filter(t => !t.odeme_durumu?.tamamlandi);
    const tamamlananlar = filteredTakipler.filter(t => t.odeme_durumu?.tamamlandi);
    return {
      toplam: filteredTakipler.reduce((sum, t) => sum + (parseFloat(t.toplam_tutar) || 0), 0),
      adet: filteredTakipler.length,
      devamEden: devamEdenler.length,
      tamamlanan: tamamlananlar.length,
      totalsByCurrency: totals
    };
  }, [filteredTakipler]);

  // Total new count for all tabs
  const totalNewCount = useMemo(() => {
    return getNewCount('girisler', girisler) + 
           getNewCount('cikislar', cikislar) + 
           getNewCount('takipler', takipler) + 
           getNewCount('cekler', cekler);
  }, [girisler, cikislar, takipler, cekler, viewedRecords, lastViewTime]);

  // Excel export
  const exportToExcel = (data, filename, headers) => {
    const BOM = '\uFEFF';
    const csvContent = BOM + [headers, ...data.map(row => 
      row.map(cell => `"${String(cell || '').replace(/"/g, '""')}"`).join(';')
    )].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.csv`;
    link.click();
  };

  const exportGirisler = () => {
    const headers = ['Tarih', 'Saat', 'Cari Hesap', 'Miktar', 'Hesap', 'Çek Karşılığı', 'Şube', 'Etiket', 'Açıklama', 'Onay Durumu', 'Onaylayan'];
    const rows = filteredGirisler.map(g => [
      g.tarih, g.saat, g.cari_hesap_adi, g.miktar, g.hesap_adi,
      g.cek_karsiligi ? 'Evet' : 'Hayır', g.fortis_sube, g.etiket_adi, g.aciklama,
      g.approval_status === 'dogru' ? 'Doğru' : g.approval_status === 'yanlis' ? 'Yanlış' : g.approval_status === 'supheli' ? 'Şüpheli' : '-',
      g.approval_by || '-'
    ]);
    exportToExcel(rows, 'girisler', headers);
  };

  const exportCikislar = () => {
    const headers = ['Tarih', 'Saat', 'Cari Hesap', 'Miktar', 'Hesap', 'Çek Karşılığı', 'Şube', 'Etiket', 'Açıklama', 'Onay Durumu', 'Onaylayan'];
    const rows = filteredCikislar.map(c => [
      c.tarih, c.saat, c.cari_hesap_adi, c.miktar, c.hesap_adi,
      c.cek_karsiligi ? 'Evet' : 'Hayır', c.fortis_sube, c.etiket_adi, c.aciklama,
      c.approval_status === 'dogru' ? 'Doğru' : c.approval_status === 'yanlis' ? 'Yanlış' : c.approval_status === 'supheli' ? 'Şüpheli' : '-',
      c.approval_by || '-'
    ]);
    exportToExcel(rows, 'cikislar', headers);
  };

  const exportTakipler = () => {
    const headers = ['Tarih', 'Cari Hesap', 'Toplam Tutar', 'Ödeme Durumu', 'Şube', 'Açıklama', 'Onay Durumu', 'Onaylayan'];
    const rows = filteredTakipler.map(t => [
      t.olusturma_tarihi, t.cari_hesap_adi, t.toplam_tutar,
      `${t.odeme_durumu?.tamamlanan || 0}/${t.odeme_durumu?.toplam || 0}`,
      t.fortis_sube, t.aciklama,
      t.approval_status === 'dogru' ? 'Doğru' : t.approval_status === 'yanlis' ? 'Yanlış' : t.approval_status === 'supheli' ? 'Şüpheli' : '-',
      t.approval_by || '-'
    ]);
    exportToExcel(rows, `takipler_${takipMainTab}`, headers);
  };

  const exportCekler = () => {
    const headers = ['Çek No', 'Banka', 'Tutar', 'Vade Tarihi', cekMainTab === 'alinan' ? 'Kesideci' : 'Alıcı', 'Durum', 'Açıklama', 'Onay Durumu', 'Onaylayan'];
    const rows = filteredCekler.map(c => [
      c.cek_no, c.banka, c.tutar, c.vade_tarihi,
      cekMainTab === 'alinan' ? c.kesideci : c.alici,
      c.durum === 'odenmis' ? 'Ödenmiş' : 'Ödenecek',
      c.aciklama,
      c.approval_status === 'dogru' ? 'Doğru' : c.approval_status === 'yanlis' ? 'Yanlış' : c.approval_status === 'supheli' ? 'Şüpheli' : '-',
      c.approval_by || '-'
    ]);
    exportToExcel(rows, `cekler_${cekMainTab}`, headers);
  };

  // Color legend component
  const ColorLegend = () => (
    <div className="flex items-center gap-4 mb-4 text-xs flex-wrap">
      <span className="flex items-center gap-1"><span className="w-4 h-4 rounded bg-blue-50 border"></span> İşlem Yapılmamış</span>
      <span className="flex items-center gap-1"><span className="w-4 h-4 rounded bg-green-50 border"></span> Doğru</span>
      <span className="flex items-center gap-1"><span className="w-4 h-4 rounded bg-red-50 border"></span> Yanlış</span>
      <span className="flex items-center gap-1"><span className="w-4 h-4 rounded bg-purple-50 border"></span> Şüpheli</span>
    </div>
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
      </div>
    );
  }

  // Sidebar menü öğeleri - Muhasebe Paneli ile aynı
  const menuItems = [
    { key: 'girisler', label: 'Girişler', icon: ArrowDownCircle, color: 'text-green-600' },
    { key: 'cikislar', label: 'Çıkışlar', icon: ArrowUpCircle, color: 'text-red-600' },
    { key: 'faturalar', label: 'Faturalar', icon: FileText, color: 'text-blue-600' },
    { key: 'takipler', label: 'Takipler', icon: Clock, color: 'text-amber-600' },
    { key: 'cekler', label: 'Çekler', icon: FileCheck, color: 'text-indigo-600' },
    { key: 'cari-hesaplar', label: 'Cari Hesaplar', icon: User, color: 'text-teal-600' },
    { key: 'hesap-kartlari', label: 'Hesap Kartları', icon: CreditCard, color: 'text-pink-600' },
    { key: 'hesaplar', label: 'Hesaplar', icon: Banknote, color: 'text-emerald-600' },
    { key: 'takvim', label: 'Takvim', icon: CalendarIcon, color: 'text-purple-600' },
    { key: 'isler', label: 'İşler', icon: Briefcase, color: 'text-indigo-600' },
    { key: 'archive', label: 'Dosyalar', icon: Archive, color: 'text-gray-600' },
    { key: 'iletisim', label: 'İletişim', icon: MessageSquare, color: 'text-blue-500' },
    { key: 'uyarilar', label: 'Uyarılar', icon: AlertTriangle, color: 'text-amber-500' },
  ];

  // İçerik render fonksiyonu
  const renderContent = () => {
    switch (innerTab) {
      case 'girisler':
        return <AccountingIncome isBoardView={true} />;
      case 'cikislar':
        return <AccountingExpenses isBoardView={true} />;
      case 'faturalar':
        return <AccountingFaturalar />;
      case 'takipler':
        return <AccountingTakipler />;
      case 'cekler':
        return <AccountingChecks />;
      case 'cari-hesaplar':
        return <AccountingCariHesaplar />;
      case 'hesap-kartlari':
        return <AccountingHesapKartlari />;
      case 'hesaplar':
        return <AccountingHesapEkle />;
      case 'takvim':
        return <AccountingCalendar />;
      case 'isler':
        return <AccountingJobs isBoardView={true} />;
      case 'archive':
        return <HRArchive />;
      case 'iletisim':
        return <AccountingCommunication />;
      case 'uyarilar':
        return <AccountingWarnings />;
      default:
        return <AccountingIncome isBoardView={true} />;
    }
  };

  return (
    <div className="flex min-h-[600px] h-full border rounded-lg overflow-hidden" data-testid="board-muhasebe">
      {/* Sol Sidebar - Muhasebe Paneli ile aynı */}
      <aside className="w-48 border-r border-gray-200 bg-white p-3 overflow-y-auto flex-shrink-0">
        <nav className="space-y-1">
          {menuItems.map((item) => (
            <button
              key={item.key}
              onClick={() => setInnerTab(item.key)}
              className={`w-full flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                innerTab === item.key
                  ? 'bg-indigo-100 text-indigo-700'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              }`}
            >
              <item.icon className={`h-4 w-4 ${item.color}`} />
              {item.label}
            </button>
          ))}
        </nav>
      </aside>

      {/* Sağ İçerik - Seçilen sayfa */}
      <main className="flex-1 overflow-auto p-4 bg-gray-50">
        {renderContent()}
      </main>
    </div>
  );
};

export default BoardBirimMuhasebe;
